import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [가상화 서비스 > 이미지 설정] 서버 이미지 목록을 조회한다.
   * @author najongdang
   * @return {[type]} [description]
   */
  getVmsImageList(params) {
    return axios.post(`${baseUrl}/settings/virtual-service-setting/get-vms-image-list.do`, params);
  },
  /**
   * [가상화 서비스 > 이미지 설정] 서버 이미지를 추가한다.
   * @author najongdang
   * @return {[type]} [description]
   */
  insertVmsImage(params) {
    return axios.post(`${baseUrl}/settings/virtual-service-setting/insert-vms-image.do`, params);
  },
  /**
   * [가상화 서비스 > 이미지 설정] 서버 이미지를 수정한다.
   * @author najongdang
   * @return {[type]} [description]
   */
  updateVmsImage(params) {
    return axios.post(`${baseUrl}/settings/virtual-service-setting/update-vms-image.do`, params);
  },
  /**
   * [가상화 서비스 > 이미지 설정] 서버 이미지 목록을 삭제한다.
   * @author najongdang
   * @return {[type]} [description]
   */
  deleteVmsImageList(params) {
    return axios.post(`${baseUrl}/settings/virtual-service-setting/delete-vms-image-list.do`, params);
  },

  /**
   * [가상화 서비스 > 이미지 설정] 가상화 서버 템플릿 목록을 조회한다.
   * @author najongdang
   * @return {[type]} [description]
   */
  getVmsTemplateList(params) {
    return axios.post(`${baseUrl}/settings/virtual-service-setting/get-vms-template-list.do`, params);
  },

  /**
   * [가상화 서비스 > 이미지 설정] 소프트웨어 타입별 가상화 이미지 소프트웨어 목록을 조회한다.
   * @author najongdang
   * @return {[type]} [description]
   */
  getVmsImageSwList() {
    return axios.get(`${baseUrl}/settings/virtual-service-setting/get-vms-imgage-sw-list.do`);
  },

  /**
   * [가상화 서비스 > 이미지 설정] 이미지 ID 별 적용 템플릿 목록을 조회한다.
   * @author najongdang
   * @return {[type]} [description]
   */
  getTargetTemplateListByVmsImage(params) {
    return axios.post(`${baseUrl}/settings/virtual-service-setting/get-target-template-list-by-vms-image.do`, params);
  },

  /**
   * [가상화 서비스 > 이미지 설정] 이미지 ID 별 적용 템플릿 목록을 설정한다.
   * @author najongdang
   * @return {[type]} [description]
   */
  updateVmsImageObjList(params) {
    return axios.post(`${baseUrl}/settings/virtual-service-setting/update-vms-image-obj-list.do`, params);
  },

  /**
   * [가상화 서비스 > 이미지 설정] 서버 이미지 중복 여부를 체크한다.
   * @author najongdang
   * @return {[type]} [description]
   */
  checkServerImageDuplication(params) {
    return axios.post(`${baseUrl}/settings/virtual-service-setting/check-server-image-duplication.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/virtual/virtual-service-settings.js